module.exports = __webpack_public_path__ + "static/leopard2-de88f085d50c416a17d443ef7eaf4ddf.png";